/**
 * Checks if the given name is a react event handler. Event handler names start
 * with "on", followed by a capital letter.
 */
export default function isEventHandler(name) {
    return /^on[A-Z]/.test(name);
}
